import { ChangeDetectorRef, Component, Input, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AddContactComponent } from 'src/app/AddThings/add-contact/add-contact.component';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { LoanRequestMessageComponent } from 'src/app/MessageClipboard/loan-request-message/loan-request-message.component';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Contact } from 'src/model/contact.model';
import { LoanRequest } from 'src/model/loanRequest.model';

@Component({
    selector: 'app-add-loan-request-guarantor',
    templateUrl: './add-loan-request-guarantor.component.html',
    styleUrls: ['./add-loan-request-guarantor.component.scss'],
    standalone: false
})
export class AddLoanRequestGuarantorComponent implements OnInit {
  private restApi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  private activeModal = inject(NgbActiveModal);
  private sharedService = inject(SharedService);
  private cdr = inject(ChangeDetectorRef);

  contactList: Contact[] = [];
  @Input() request: LoanRequest;

  disabledSubmit = false;

  ngOnInit(): void {
    this.getContactInfo();
  }

  getContactInfo() {
    const xhttp = this.restApi.getRequest(this.constructApi.getCustomerContact(this.request.CustomerId));
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const jsonArray = JSON.parse((xhttp.responseText));
        jsonArray.forEach(json => {
          const contact = new Contact(json.id, json.name, json.icNumber, json.number, json.address, json.customerId, json.relation, json.remark, false);
          //add customer instance into customer list
          this.contactList.push(contact);
        });
      }
    };
  }

  getContactClass(isSelected: boolean) {
    if (isSelected == true)
      return 'selectedContactCard';
    else
      return 'contactCard'
  }

  changeIsContactSelected(i: number) {
    this.contactList[i].IsSelected = !this.contactList[i].IsSelected;
  }

  addContact() {
    const modalRef = this.sharedService.openModal(AddContactComponent);
    modalRef.componentInstance.viewCustomerId = this.request.CustomerId;

    //get added loan
    modalRef.componentInstance.passEntry.subscribe((entry) => {
      const contact = entry;

      //append added loan to loan list
      this.contactList.push(contact);
    });

    modalRef.result.then(() => {
      //detect changes
      this.cdr.detectChanges();
    })
  }

  reset() {
    this.activeModal.close();
  }

  submit() {
    const guarantorIdData: number[] = [];
    for (let i = 0; i < this.contactList.length; i++) {
      if (this.contactList[i].IsSelected == true)
        guarantorIdData.push(this.contactList[i].ID);
    }

    const data = {
      "profileId": this.request.ProfileId,
      "loanInfo": this.request.LoanInfo,
      "remark": this.request.Remark,
      "requestOn": new Date().toISOString(),
      "guarantorIds": guarantorIdData
    }

    const xhr = this.restApi.putRequest(this.constructApi.getUpdateEPFLoanRequest(this.request.ID), data)
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        this.disabledSubmit = false;
        //if success , then proceed
        if (xhr.status == 200) {
          // window.location.reload();

          const json = JSON.parse(xhr.responseText);
          this.request.ID = Number(json.id);
          const modalRef = this.sharedService.openModal(LoanRequestMessageComponent);
          modalRef.componentInstance.request = this.request;
          modalRef.componentInstance.isDirty = true;

          this.reset();
        }
        else {
          //show error message
          this.sharedService.openAlert(JSON.parse(xhr.responseText).error, ALERT_TYPE.DANGER)
        }
      }
    }
  }
}
